import React from 'react';
import PropTypes from 'prop-types';
import { buildDefaultAltTag, preventTabNabbing } from '../../../lib/helpers';

const ImageButtons = ({
  imageButtons,
  handleClickFPTI,
  toolName,
  app = {}
}) => {
  const { context: { location: { domain } = {} } = {} } = app;
  return imageButtons && imageButtons.length > 0
    ? imageButtons.map((item, index) => {
        const alt = item.alt || buildDefaultAltTag(toolName, item.icon);
        if (!item.url) {
          return null;
        }
        return (
          <a
            key={index}
            href={item.url}
            target="_blank"
            rel={preventTabNabbing(item.url, domain)}
            className={'add-focus-visible'}
            onClick={() => handleClickFPTI(item.fptiLinkName)}
          >
            <img
              className="details-option-image-button-image"
              src={item.icon}
              alt={alt}
            />
          </a>
        );
      })
    : null;
};

export default ImageButtons;

ImageButtons.propTypes = {
  imageButtons: PropTypes.array,
  handleClickFPTI: PropTypes.func,
  toolName: PropTypes.string,
  app: PropTypes.object
};
